import { Divider, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { useEffect, useState } from "react";
import { BooleanField, Datagrid, DateField, ListContextProvider, Pagination, TextField, useList } from "react-admin";
import dataProvider from "../../../providers/data-provider";
import { DashboardButton } from "../../dashboard-button";
import { TimeIconField } from "../../time-icon-field";

const TeacherDashboardActivities = (props) => {

    const [page, setPage] = useState(1)
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)
    const [value, setValue] = useState('pending');
    const [filter, setFilter] = useState({ finished: false })
    const [loaded, setLoaded] = useState(false)
    const [perPage, setPerPage] = useState(10)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        (async () => {
            setLoading(true)
            setLoaded(false)
            const resp = await dataProvider.get('teacher', 'activity-dashboard', { filter: JSON.stringify(filter), page, limit: perPage })
            setData(resp.data.data)
            setTotal(resp.data.total)
            setLoading(false)
            setLoaded(true)
        })()
    }, [filter, page, perPage])

    const ids = data.map((row) => row.id)
    const sort = { field: 'effective_deadline', order: 'DESC' };
    const context = useList({ data, ids, loading, loaded, page, perPage, sort, filter })

    const handleChange = (event) => {
        let value = event.target.value;
        setValue(value);
        switch (value) {
            case 'all':
                setFilter({})
                break;
            case 'pending':
            default:
                setFilter({ finished: false })
                break;
            case 'finished':
                setFilter({ finished: true })
                break;
        }
    }

    return (
        <>
            <FormControl style={{ marginBlock: '10px', marginInline: '10px', minWidth: '150px' }}>
                <InputLabel id={'filter-select-label'}>Filtro</InputLabel>
                <Select labelId={'filter-select-label'} id={'filter-select'} value={value} disabled={loading} onChange={handleChange} variant="filled">
                    <MenuItem value={'all'}> Todos </MenuItem>
                    <MenuItem value={'pending'}>Em aberto</MenuItem>
                    <MenuItem value={'finished'}>Finalizadas</MenuItem>
                </Select>
            </FormControl>
            <Divider />

            <ListContextProvider value={context}>
                <Datagrid loaded={context.loaded} basePath="/activities" resource="activity">
                    <TimeIconField source="effective_deadline" label={'Legenda'} />
                    <TextField source="process.alias" label={'Protocolo'} />
                    <TextField source="process.client.name" label={'Cliente'} />
                    <TextField source="type.name" label={'Movimentação'} />
                    <DateField source="deadline" label={'Prazo aluno'} />
                    <DateField source="effective_deadline" label={'Prazo final'} />
                    <BooleanField source="finished" label={'Finalizado?'} />
                    <TextField source="institution_branch.name" label={'Unidade'} />
                    <DashboardButton />
                </Datagrid>
                <Pagination total={total} page={page} setPage={setPage} setPerPage={setPerPage} perPage={perPage} rowsPerPageOptions={[5, 10, 25]} />
            </ListContextProvider>
        </>
    )
}

export default TeacherDashboardActivities